import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
    selector: 'risk-profil-second-part',
    templateUrl: './risk-profil-second-part.component.html',
    styleUrls: ['./risk-profil-second-part.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class RiskProfilSecondPartComponent implements OnInit {
  options = [
    {
      label: 'Oui',
      value: 'YES',
    },
    {
      label: 'Non',
      value: 'NO',
    },
  ];
  constructor() {}

  ngOnInit() {}
}
